const railButtons = document.querySelectorAll("[data-scroll]");

railButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const rail = document.getElementById(button.dataset.scroll);
    const direction = Number(button.dataset.dir || 1);
    if (!rail) return;
    rail.scrollBy({
      left: direction * Math.max(rail.clientWidth * 0.72, 280),
      behavior: "smooth",
    });
  });
});

const giftTabs = document.querySelectorAll(".tabs button");

giftTabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    giftTabs.forEach((item) => {
      item.classList.toggle("active", item === tab);
      item.setAttribute("aria-selected", String(item === tab));
    });
  });
});

const categoryButtons = document.querySelectorAll(".food-categories button");
const quickProducts = document.querySelectorAll(".quick-product");

categoryButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const selectedCategory = button.dataset.category;

    categoryButtons.forEach((item) => item.classList.toggle("active", item === button));
    quickProducts.forEach((product) => {
      const categories = product.dataset.category || "";
      product.classList.toggle("is-hidden", selectedCategory !== "all" && !categories.includes(selectedCategory));
    });
  });
});

document.querySelectorAll(".quick-add").forEach((button) => {
  button.addEventListener("click", () => {
    if (button.closest(".kr-add-form[data-collection-quick-add='true']")) return;
    const current = Number(button.dataset.qty || 0) + 1;
    button.dataset.qty = String(current);
    button.textContent = current > 1 ? String(current) : "1";
    button.setAttribute("aria-label", `Quantity ${current}`);
  });
});

document.querySelectorAll(".shopify-product > button").forEach((button) => {
  button.addEventListener("click", () => {
    button.textContent = "Added";
    button.classList.add("is-added");
  });
});

document.querySelectorAll(".kuuraii-proto .product-gallery").forEach((gallery) => {
  const mainImage = gallery.querySelector(".product-main-image");
  const mobileGallery = gallery.querySelector(".product-mobile-media");

  const mobileSlides = Array.from(
    gallery.querySelectorAll(".product-mobile-media__slide")
  );

  const thumbnailButtons = Array.from(
    gallery.querySelectorAll(".product-thumbs button[data-image]")
  );

  if (!thumbnailButtons.length) return;

  function setMainImageMode(mode) {
    if (!mainImage) return;

    mainImage.dataset.mediaMode = mode === "document" ? "document" : "photo";
  }

  function setActiveThumbnail(activeIndex) {
    thumbnailButtons.forEach((button, index) => {
      const isActive = index === activeIndex;

      button.classList.toggle("active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function scrollMobileGalleryToSlide(index) {
    if (!mobileGallery || !mobileSlides[index]) return;

    const slide = mobileSlides[index];
    const galleryRect = mobileGallery.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();

    const targetLeft =
      mobileGallery.scrollLeft +
      slideRect.left -
      galleryRect.left;

    mobileGallery.scrollTo({
      left: targetLeft,
      behavior: "smooth",
    });
  }

  thumbnailButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      const thumbnailImage = button.querySelector("img");
      const fullImage = button.dataset.image || thumbnailImage?.src;
      const imageAlt = button.dataset.imageAlt || thumbnailImage?.alt;

      setActiveThumbnail(index);
      setMainImageMode(button.dataset.mediaMode);

      /*
       * Desktop image change.
       * Remove Shopify's srcset so it does not keep displaying
       * the previously selected responsive image.
       */
      if (mainImage && fullImage) {
        mainImage.removeAttribute("srcset");
        mainImage.removeAttribute("sizes");
        mainImage.src = fullImage;

        if (imageAlt) {
          mainImage.alt = imageAlt;
        }
      }

      /*
       * Mobile uses a separate horizontal image gallery.
       * Move that gallery to the tapped thumbnail's image.
       */
      if (window.matchMedia("(max-width: 749px)").matches) {
        scrollMobileGalleryToSlide(index);
      }
    });
  });

  /*
   * Update the highlighted thumbnail when the customer
   * manually swipes the mobile image gallery.
   */
  if (mobileGallery && mobileSlides.length) {
    let scrollFrame;

    mobileGallery.addEventListener(
      "scroll",
      () => {
        if (scrollFrame) {
          cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = requestAnimationFrame(() => {
          const galleryRect = mobileGallery.getBoundingClientRect();
          const galleryCenter =
            galleryRect.left + galleryRect.width / 2;

          let nearestIndex = 0;
          let nearestDistance = Infinity;

          mobileSlides.forEach((slide, index) => {
            const slideRect = slide.getBoundingClientRect();
            const slideCenter =
              slideRect.left + slideRect.width / 2;

            const distance = Math.abs(
              galleryCenter - slideCenter
            );

            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          if (nearestIndex < thumbnailButtons.length) {
            setActiveThumbnail(nearestIndex);
          }
        });
      },
      { passive: true }
    );
  }

  const initialActiveIndex = thumbnailButtons.findIndex((button) =>
    button.classList.contains("active")
  );
  setMainImageMode(thumbnailButtons[Math.max(initialActiveIndex, 0)]?.dataset.mediaMode);
});

document.querySelectorAll(".variant-row button").forEach((button) => {
  button.addEventListener("click", () => {
    const group = button.closest(".variant-row");
    group?.querySelectorAll("button").forEach((item) => item.classList.toggle("active", item === button));

    const root = button.closest("[data-product-root]");
    const variantInput = root?.querySelector("[data-variant-input]");
    const priceNode = root?.querySelector("[data-product-price]");
    const compareNode = root?.querySelector("[data-product-compare-price]");
    const badgeNode = root?.querySelector("[data-product-badge]");
    const addToCart = root?.querySelector("[data-add-to-cart]");
    const preorderProperty = root?.querySelector("[data-preorder-property]");
    const selectedSizeDetail = root?.querySelector("[data-selected-size-detail]");
    const selectedBedSize = root?.querySelector("[data-selected-bed-size]");
    const selectedStockStatus = root?.querySelector("[data-selected-stock-status]");

    if (variantInput && button.dataset.variantId) {
      variantInput.value = button.dataset.variantId;
    }
    if (priceNode && button.dataset.variantPrice) {
      priceNode.innerHTML = button.dataset.variantPrice;
    }
    if (compareNode) {
      compareNode.innerHTML = button.dataset.variantCompare || "";
    }
    if (badgeNode) {
      const nextBadge = button.dataset.variantBadge || "";
      badgeNode.textContent = nextBadge;
      badgeNode.hidden = !nextBadge;
    }
    if (addToCart) {
      const available = button.dataset.variantAvailable !== "false";
      const preorder = button.dataset.variantPreorder === "true";
      addToCart.disabled = !available && !preorder;
      addToCart.textContent = preorder ? "Pre-order now" : available ? "Add to cart" : "Sold out";
      if (preorderProperty) {
        preorderProperty.disabled = !preorder;
      }
    }
    if (selectedSizeDetail) selectedSizeDetail.textContent = button.dataset.variantDetail || "";
    if (selectedBedSize && button.dataset.variantBedSize) selectedBedSize.textContent = button.dataset.variantBedSize;
    if (selectedStockStatus) {
      const available = button.dataset.variantAvailable !== "false";
      const preorder = button.dataset.variantPreorder === "true";
      selectedStockStatus.textContent = preorder ? "Pre-order" : available ? "Ready to ship" : "Sold out";
    }
  });
});

document.querySelectorAll(".add-cart, .buy-now, .mobile-purchase-bar button").forEach((button) => {
  button.addEventListener("click", () => {
    button.textContent = button.classList.contains("buy-now") ? "Checking out" : "Added";
  });
});
